module.exports = __webpack_public_path__ + "3457a8c4c51b94827b9313425aa5f043.svg";